export enum VideoType {
  VIMEO = 'VIMEO',
  YOUTUBE = 'YOUTUBE',
}

export const getYouTubeVideoId = (url: string): string | null => {
  const youtubeURLRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|v\/|watch\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(youtubeURLRegex);
  return match ? match[1] : null;
};

export const getVimeoVideoId = (url: string): string | null => {
  const pattern = /vimeo\.com\/(\d+)/;
  const matches = url.match(pattern);
  return matches?.[1] || null;
};

export const getVideoType = (value: string): string => {
  return isVimeoLink(value) ? VideoType.VIMEO : VideoType.YOUTUBE;
};

export const getVideoId = (url: string): string | null => {
  if (isVimeoLink(url)) {
    return getVimeoVideoId(url);
  }

  if (isYoutubeLink(url)) {
    return getYouTubeVideoId(url);
  }

  return null;
};

export const isYoutubeLink = (inputValue: string): boolean => {
  const youtubeURLRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|v\/|watch\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  return youtubeURLRegex.test(inputValue);
};

export const isVimeoLink = (inputValue: string): boolean => {
  const vimeoURLRegex = /^(https?:\/\/)?(www\.)?(vimeo\.com\/)([0-9]{8,})/;
  return vimeoURLRegex.test(inputValue);
};

export const getVideoThumbnailURL = async (videoId: string, videoType: string): Promise<any> => {
  return (
    await window.PMW.writeLocal('emailmaker/processEmbeddedVideoUrl', {
      videoId,
      videoType,
    })
  ).thumbnailURL;
};

export const validateInputLink = (inputValue: string): boolean => {
  return isVimeoLink(inputValue) || isYoutubeLink(inputValue);
};
